import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const BackIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 7 14">
    <path
      d="M6 1.5L2 7L6 12.5"
      strokeLinecap="round"
      strokeWidth={2}
      fill="transparent"
    />
  </SvgIcon>
);
